import { render, staticRenderFns } from "./User.vue?vue&type=template&id=c44503a4&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
import style0 from "./User.vue?vue&type=style&index=0&id=c44503a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44503a4",
  null
  
)

export default component.exports